import { sortEntity as sortUser } from 'endpoints/users';
import { DATA } from 'app/constants';

import { sortEntity } from '../../endpoints/users';

const INIT_STATE = { users: null, editMode: false, serviceLocations: [], roles: null };

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'data/load/USERS':
      return { ...state, users: action.users };
    case 'data/new/USERS':
      return {
        ...state,
        users: [action.user].concat(state.users).sort(sortUser),
      };
    case 'data/update/USERS':
      return {
        ...state,
        users: state.users
          .map((user) =>
            user.id == action.id ? { ...user, ...action.changes } : user
          )
          .sort(sortEntity),
      };
    case 'data/delete/USERS':
      return {
        ...state,
        users: state.users.filter((u) => !action.ids.includes(u.id)),
      };
    case 'data/editMode/On': {
      return { ...state, editMode: true };
    }
    case 'data/editMode/Off': {
      return { ...state, editMode: false };
    }
    case DATA.SET_USER_ROLES: {
      return { ...state, roles: action.payload };
    }
    case DATA.SET_USER_COUNTRIES: {
      return { ...state, serviceLocations: action.payload };
    }
    default:
      return state;
  }
};
